import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { PageHeader } from '@/components/PageHeader';
import { IntelligentDocumentClassification } from '@/components/IntelligentDocumentClassification';
import { RealTimeProcessingPipeline } from '@/components/RealTimeProcessingPipeline';
import { AdvancedIntegrationHub } from '@/components/AdvancedIntegrationHub';
import { QualityControlDashboard } from '@/components/QualityControlDashboard';

const AdvancedProcessing: React.FC = () => {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Advanced Processing Engine"
        description="Phase 4: Intelligent document processing and automation"
      />

      <Tabs defaultValue="classification" className="w-full">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="classification">Document Classification</TabsTrigger>
          <TabsTrigger value="pipeline">Real-Time Pipeline</TabsTrigger>
          <TabsTrigger value="integrations">Integration Hub</TabsTrigger>
          <TabsTrigger value="quality">Quality Control</TabsTrigger>
        </TabsList>

        <TabsContent value="classification" className="space-y-6">
          <IntelligentDocumentClassification />
        </TabsContent>

        <TabsContent value="pipeline" className="space-y-6">
          <RealTimeProcessingPipeline />
        </TabsContent>

        <TabsContent value="integrations" className="space-y-6">
          <AdvancedIntegrationHub />
        </TabsContent>

        <TabsContent value="quality" className="space-y-6">
          <QualityControlDashboard />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AdvancedProcessing;